// AxesToggle.js — frosted pill that switches the grid between home–away and
// winner–loser axes. Visually paired with SeasonSelect.

import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { BRAND } from "../../theme";
import { HOME_AWAY, WINNER_LOSER } from "./utils";

const OPTIONS = [
  { value: HOME_AWAY, label: "Home / Away", title: "Home goals × away goals" },
  { value: WINNER_LOSER, label: "Winner / Loser", title: "Final score, whoever was at home" },
];

export default function AxesToggle({ axes, onChange }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <ToggleButtonGroup
      value={axes}
      exclusive
      size="small"
      aria-label="Grid axes"
      onChange={(_, v) => v && onChange(v)}
      sx={{
        borderRadius: 999,
        p: 0.25,
        background: "rgba(20,20,26,0.7)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        border: `1px solid ${BRAND.divider}`,
        boxShadow:
          "0 4px 20px rgba(0,0,0,0.45), inset 0 0 0 1px rgba(255,255,255,0.04)",
        "& .MuiToggleButton-root": {
          border: "none",
          borderRadius: "999px !important",
          px: isMobile ? 1 : 1.5,
          py: 0.4,
          fontSize: isMobile ? 11 : 12,
          fontWeight: 700,
          letterSpacing: "0.04em",
          textTransform: "none",
          whiteSpace: "nowrap",
          color: BRAND.textSecondary,
          "&:hover": { color: "#fff", background: "rgba(111,93,245,0.12)" },
          "&.Mui-selected, &.Mui-selected:hover": {
            color: "#fff",
            background: BRAND.gradient,
          },
        },
      }}
    >
      {OPTIONS.map((o) => (
        <ToggleButton key={o.value} value={o.value} title={o.title} aria-label={o.label}>
          {o.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
